import styled from "styled-components";
import {Button, Input, InputNumber, Radio, Select} from "antd";
import {useEffect, useState} from "react";

interface LsEditModalProps {
    close: () => void;
    name?: string;
    type: "WG" | "LIGHT";
    zoneNo: number | null;
    stores: {no: number; name: string}[];
}

const LsEditModal = ({close, name, type, zoneNo, stores}: LsEditModalProps) => {
    const [selectedZoneNo, setSelectedZoneNo] = useState<number | null>(null);
    const [wgInputs, setWgInputs] = useState<{
        id: string;
        name: string;
    }>({
        id: "",
        name: "",
    });
    const [lightInputs, setLightInputs] = useState<{
        wgId: string;
        wgNo: number;
        lineNo: string;
        subNo: string;
        name: string;
        lineType: string;
        isOutdoor: boolean;
        order: number | null;
    }>({
        wgId: "",
        wgNo: null,
        lineNo: "",
        subNo: "",
        name: "",
        lineType: "",
        isOutdoor: false,
        order: null,
    });

    const wgConfirm = () => {
        console.log(wgInputs);
        console.log(selectedZoneNo);
    };

    const lightConfirm = () => {
        console.log(lightInputs);
        console.log(selectedZoneNo);
    };

    useEffect(() => {
        setSelectedZoneNo(zoneNo);
    }, [zoneNo]);
    return (
        <Background>
            <Container>
                <p className={"title"}>
                    {type === "LIGHT" ? "조명" : type} {name ? "수정하기" : "추가하기"} {name && " [ " + name + " ]"}
                </p>
                <InputBox>
                    <p>지점</p>
                    <Select
                        style={{width: 300}}
                        className={"select"}
                        placeholder={"지점선택"}
                        value={selectedZoneNo}
                        disabled={zoneNo !== null}
                        onChange={(e) => setSelectedZoneNo(e)}
                        showSearch
                        filterOption={(input, option) => {
                            if (option && typeof option.label === "string") {
                                return option.label.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }}
                        options={stores.map((item) => ({label: item.name + ` (${item.no})`, value: item.no}))}
                    />
                </InputBox>
                {type === "WG" ? (
                    <>
                        <InputBox>
                            <p>ID</p>
                            <Input
                                placeholder={"ID 입력"}
                                value={wgInputs.id}
                                onChange={(e) => setWgInputs((p) => ({...p, id: e.target.value}))}
                            />
                        </InputBox>
                        <InputBox>
                            <p>이름</p>
                            <Input
                                placeholder={"이름 입력"}
                                value={wgInputs.name}
                                onChange={(e) => setWgInputs((p) => ({...p, name: e.target.value}))}
                            />
                        </InputBox>
                        <div className={"button-container"}>
                            <Button onClick={wgConfirm}>확인</Button>
                            <Button onClick={close}>취소</Button>
                        </div>
                    </>
                ) : (
                    <>
                        <InputBox>
                            <p>WG ID</p>
                            <Select
                                placeholder={"WG ID 선택"}
                                style={{width: 400}}
                                showSearch
                                filterOption={(input, option) => {
                                    if (option && typeof option.label === "string") {
                                        return option.label.toLowerCase().includes(input.toLowerCase());
                                    }
                                    return false;
                                }}
                            />
                        </InputBox>
                        <InputBox>
                            <p>lineNo</p>
                            <Input
                                placeholder={"lineNo 입력"}
                                value={lightInputs.lineNo}
                                onChange={(e) => setLightInputs((p) => ({...p, lineNo: e.target.value}))}
                            />
                        </InputBox>
                        <InputBox>
                            <p>subNo</p>
                            <Input
                                placeholder={"subNo 입력"}
                                value={lightInputs.subNo}
                                onChange={(e) => setLightInputs((p) => ({...p, subNo: e.target.value}))}
                            />
                        </InputBox>
                        <InputBox>
                            <p>이름</p>
                            <Input
                                placeholder={"이름 입력"}
                                value={lightInputs.name}
                                onChange={(e) => setLightInputs((p) => ({...p, name: e.target.value}))}
                            />
                        </InputBox>
                        <InputBox>
                            <p>lineType</p>
                            <Select
                                placeholder={"lineType 입력"}
                                style={{width: 400}}
                                value={lightInputs.lineType}
                                onChange={(e) => setLightInputs((p) => ({...p, lineType: e}))}
                            />
                        </InputBox>
                        <InputBox>
                            <p>isOutdoor</p>
                            <Radio.Group
                                value={lightInputs.isOutdoor}
                                onChange={(e) => setLightInputs((p) => ({...p, isOutdoor: e.target.value}))}
                            >
                                <Radio value={true}>Y</Radio>
                                <Radio value={false}>N</Radio>
                            </Radio.Group>
                        </InputBox>
                        <InputBox>
                            <p>order</p>
                            <InputNumber
                                placeholder={"order 입력"}
                                style={{width: "100%"}}
                                value={lightInputs.order}
                                onChange={(e) => setLightInputs((p) => ({...p, order: e}))}
                            />
                        </InputBox>
                        <div className={"button-container"}>
                            <Button onClick={lightConfirm}>확인</Button>
                            <Button onClick={close}>취소</Button>
                        </div>
                    </>
                )}
            </Container>
        </Background>
    );
};

export {LsEditModal};

const Background = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.66);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Container = styled.div`
    width: 600px;
    background: white;
    padding: 24px;

    .title {
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        padding-bottom: 5px;
        border-bottom: 2px solid #6da4ea;
    }

    .button-container {
        margin-top: 24px;
        text-align: right;

        button {
            margin-left: 8px;
            font-weight: 500;

            &:first-child {
                background-color: #6da4ea;
                color: white;
            }
        }
    }
`;

const InputBox = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    p {
        width: 100%;
        margin: 15px 0 5px;
    }

    .ant-select-disabled {
        color: red !important;
    }
`;
